import { render, staticRenderFns } from "./SelfDeliveryType.vue?vue&type=template&id=55b370ca&"
import script from "./SelfDeliveryType.vue?vue&type=script&lang=ts&"
export * from "./SelfDeliveryType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports